export default __webpack_public_path__ + "static/media/home_favourite_movie.2abf8e66.mp3";